import { createCase, createSwitch } from 'helpers/action-helpers';
import update from 'immutability-helper';
import { initialState } from './state';
import { TermsAcceptedAction, FillTermsAction, TermsIgnoredAction } from './actions';

export const termsReducer = createSwitch(initialState, [
  createCase(new TermsAcceptedAction(''), (state, action) => {
    if (action.id === state.optelTerms.id) {
      return update(state, {
        optelTerms: {
          isAccepted: { $set: true }
        }
      });

    } else if (action.id === state.nmvsTerms.id) {
      return update(state, {
        nmvsTerms: {
          isAccepted: { $set: true }
        }
      });
    }

    return state;
  }),
  createCase(new TermsIgnoredAction(), (state, action) => {
    return update(state, {
      nmvsTerms: {
        isAccepted: { $set: true }
      }
    });
  }),
  createCase(new FillTermsAction(undefined, undefined), (state, action) => {
    if (action.nmvsTerms === null) {
      action.nmvsTerms = {
        id: '',
        content: '',
        isAccepted: true
      };
    }
    if (action.optelTerms === null) {
      action.optelTerms = {
        id: '',
        content: '',
        isAccepted: true
      };
    }
    return update(state, {
      optelTerms: { $set: action.optelTerms },
      nmvsTerms: { $set: action.nmvsTerms }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/pages/terms-of-use/reducer.ts